import { Link } from 'react-router-dom';
import { videos } from '@/mocks/homeData';
import VideoCard from '@/pages/home/components/VideoCard';

export default function PopularSection() {
  const popularVideos = [...videos].sort(() => Math.random() - 0.5).slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">热门视频</h2>
            <p className="text-sm text-foreground-600 mt-1">大家都在看的内容</p>
          </div>
          <Link to="/category/duanshipin" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200">
            查看更多 <i className="ri-arrow-right-line align-middle"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {popularVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}